import React from 'react';
import PropTypes from 'prop-types';

import AddImage from '../../../../../../ImageManager/Add';
import { slideObjectPropTypes } from '../../../../../Utils';
import { insertIntoEditor } from '../FroalaListeners';
import useSlideShowImageFetcher from '../../../../../Utils/useSlideShowImageFetcher.ts';
import useSlideShowContext from '../../../../../stores/useSlideShowContext';

const CustomImageModal = ({
  clearDefaultImage, editorInstance, fromButton, modalManager, pastedImage, slideObject,
}) => {
  const { fetchImages } = useSlideShowImageFetcher();
  const isAdmin = useSlideShowContext(state => state.isAdmin);
  const locale = useSlideShowContext(state => state.locale);
  const updateSlideObject = useSlideShowContext(state => state.updateSlideObject);

  const imageTag = (imageModel) => {
    const { image: { imageUrl, imageEsUrl, descriptionEn, descriptionEs } } = imageModel;
    const src = locale === 'es' && imageEsUrl && !imageEsUrl.includes('missing.png') ? imageEsUrl : imageUrl;
    const description = locale === 'es' ? descriptionEs || descriptionEn : descriptionEn;

    const img = (
      <img
        alt={description || ''}
        className={fromButton ? '' : 'imageInTextObject'}
        data-snippet={imageModel.snippet}
        data-zoomurl={src}
        src={src}
      />
    );

    // AIDEV-NOTE: Wrap in zoom wrapper at insert time so present mode doesn't need to mutate the DOM.
    if (imageModel.zoomType) {
      return <div className="image-zoom-icon-wrapper">{img}</div>;
    }

    return img;
  };

  const afterSave = (res) => {
    const imageModel = res.length ? res[0] : res;
    insertIntoEditor(editorInstance, imageTag(imageModel), true, false, fromButton);

    updateSlideObject({
      ...slideObject,
      imageModels: [...(slideObject.imageModels || []), imageModel],
    });
  };

  return (
    <AddImage
      forFroala
      fromSlideShow
      afterMergeDuplicates={afterSave}
      afterSubmit={afterSave}
      clearDefaultImage={clearDefaultImage}
      defaultImage={pastedImage}
      dontMergeCallback={afterSave}
      dropdownOptions={{
        zoom_type: [
          { label: 'in/out buttons', value: 'in/out buttons' },
          { label: 'none', value: '' },
        ]
      }}
      excludeFields={['display_size', 'alignment', 'caption_en', 'caption_es']}
      fromButton={fromButton}
      getExistingImages={fetchImages}
      isAdmin={isAdmin}
      modalManager={modalManager}
      modelId={parseInt(slideObject.id, 10)}
      modelType="SlideObject"
      standaloneButton={false}
    />
  );
};

CustomImageModal.propTypes = {
  clearDefaultImage: PropTypes.func,
  editorInstance: PropTypes.object,
  fromButton: PropTypes.bool,
  modalManager: PropTypes.shape({
    close: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    open: PropTypes.func.isRequired
  }).isRequired,
  pastedImage: PropTypes.object,
  slideObject: slideObjectPropTypes.isRequired,
};

CustomImageModal.defaultProps = {
  clearDefaultImage: () => {},
  editorInstance: {},
  fromButton: false,
  pastedImage: null,
};

export default CustomImageModal;
